/**
 * Builds the `search_performed` event fired when the header search bar is
 * submitted. Fires on every submit — including an empty query, since a
 * cleared search is itself a signal — see HeaderSearch.tsx.
 *
 * `resultCount` is passed in rather than derived here: only the caller has
 * dispatched the filter and can see what it matched. `null` is the honest
 * answer when the /browse catalogue has not been loaded yet — see
 * `SearchPerformedProperties.result_count`.
 */

import { getSessionId } from "./session";
import type { SearchPerformedEvent } from "./types";

export const buildSearchPerformedEvent = (
  query: string,
  resultCount: number | null = null,
): SearchPerformedEvent => ({
  name: "search_performed",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: { query, result_count: resultCount },
});
